/* unplugin-vue-components disabled */import script from "./SlideBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SlideBar.vue?vue&type=script&setup=true&lang=js"

import "./SlideBar.vue?vue&type=style&index=0&id=32bcba76&lang=scss"

const __exports__ = script;

export default __exports__